import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignUpHusbandDetails() {
    const navigate = useNavigate();
   
   
      
      const [isSubmitting, setIsSubmitting] = useState(false);

      const [husbandDetails, setHusbandDetails] = useState({
        first_name: '',
        last_name: '',
        status: false,     // deceased
        inactive: false,   // inactive
        email: '',
        phone_number: ''
      });
      
      const [isSubmittingM, setIsSubmittingM] = useState(false);
      
      const handleCheckboxChange = (field) => {
        setHusbandDetails((prev) => ({
          ...prev,
          [field]: !prev[field]
        }));
      };
      
      const handleFamilyMarriedSubmit = async () => {
        if (!husbandDetails.first_name.trim() || !husbandDetails.last_name.trim()) {
          toast.error("Fill empty fields.");
          return;
        }
      
        setIsSubmittingM(true);
      
        try {
          const payload = {
            ...husbandDetails,
            ...(husbandDetails.status || husbandDetails.inactive
              ? { email: '', phone_number: '' }
              : {})
          };
      
          const res = await axios.post(
            `${API_URL}/reg-signup-family-married-update-api`,
            payload,
            { withCredentials: true }
          );
      
          if (res.data.Status === "Success") {
            navigate(res.data.redirect);
          } else {
            toast.error("Failed to submit.");
          }
        } catch (error) {
          console.error("Family update failed:", error);
          toast.error("Something went wrong.");
        } finally {
          setIsSubmittingM(false);
        }
      };
      


    return (
        
        <div className="text-whitex">
  <div id="page">
    <ToastContainer />
    <div className="page-content pb-0">

      {/* Flexbox container to center content */}
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <div className="col-md-8 col-lg-6"> {/* controls card width */}
          <div className="card shadow-lg">
            <div className="card-body">

              <h5 className="text-center">Husband's Details</h5>

              <div className="row husband-dtls">
                <div className="col-6 col-md-6">
                  <label>First name</label>
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    required
                    value={husbandDetails.first_name}
                    onChange={(e) =>
                      setHusbandDetails({ ...husbandDetails, first_name: e.target.value })
                    }
                  />
                </div>
                <div className="col-6 col-md-6">
                  <label>Last name</label>
                  <input
                    type="text"
                    name="last_name"
                    className="form-control"
                    required
                    value={husbandDetails.last_name}
                    onChange={(e) =>
                      setHusbandDetails({ ...husbandDetails, last_name: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* Show Email/Phone only if not deceased and not inactive */}
              {!husbandDetails.status && !husbandDetails.inactive && (
                <div className="row husband-dtls mb-3">
                  <div className="col-6 col-md-6">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={husbandDetails.email}
                      onChange={(e) =>
                        setHusbandDetails({ ...husbandDetails, email: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-6 col-md-6">
                    <label>Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={husbandDetails.phone_number}
                      onChange={(e) =>
                        setHusbandDetails({ ...husbandDetails, phone_number: e.target.value })
                      }
                    />
                  </div>
                </div>
              )}

              <div className="row husband-dtls mt-4">
                <div className="col-12">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="deceased"
                    checked={husbandDetails.status}
                    onChange={() =>
                      setHusbandDetails({
                        ...husbandDetails,
                        status: !husbandDetails.status,
                        inactive: false,
                      })
                    }
                  />
                  <label className="form-check-label ms-2" htmlFor="deceased">
                    Deceased
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="inactive"
                    checked={husbandDetails.inactive}
                    onChange={() =>
                      setHusbandDetails({
                        ...husbandDetails,
                        inactive: !husbandDetails.inactive,
                        status: false,
                      })
                    }
                  />
                  <label className="form-check-label ms-2" htmlFor="inactive">
                    Inactive
                  </label>
                </div>
              </div>

              <div className="row text-center mt-4">

              <div className="d-flex justify-content-between mt-4x">
              <Link onClick={() => navigate(-1)} className="btn btn-primary">
                    Back
                  </Link>
    
                  <button
                    onClick={handleFamilyMarriedSubmit}
                    className="btn btn-primary"
                    type="submit"
                    disabled={isSubmittingM}
                  >
                    Submit
                  </button>
              </div>
                
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


    );
}

export default SignUpHusbandDetails;
